module.exports = __webpack_public_path__ + "img/13.165f4641.jpg";